<template>
  <div class="btn-container">
    <div class="w-100">
      <v-btn
        :disabled="isDisabled"
        v-if="isShowButton"
        :loading="loading"
        hide-details
        class="btn"
        :class="[outlined ? 'btn-outlined' : '']"
        tabindex="3"
      >
        <slot></slot>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
    },
    isShowButton: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: "62px",
    },
    width: {
      type: String,
      default: "100%",
    },
    boxShadow: {
      type: String,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: "#BD9478",
    },
    textColor: {
      type: String,
      default: "white",
    },
    paddingLeft: {
      type: String,
      default: "0px",
    },
    paddingRight: {
      type: String,
      default: "0px",
    },
    paddingTop: {
      type: String,
      default: "0px",
    },
    paddingBottom: {
      type: String,
      default: "0px",
    },
  },
};
</script>

<style lang="scss"></style>

<style scoped lang="scss">
.btn-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .btn {
    height: fit-content;
    width: v-bind(width);
    padding-left: v-bind(paddingLeft);
    padding-right: v-bind(paddingRight);
    padding-top: v-bind(paddingTop);
    padding-bottom: v-bind(paddingBottom);
    border-radius: 5px !important;
    background: v-bind(backgroundColor);
    font-size: $mediumTextSize;
    color: v-bind(textColor);
    font-weight: 400;
    line-height: 26.44px;
    letter-spacing: 0;
    box-shadow: v-bind(boxShadow);
  }

  .btn-outlined {
    background: white;
    color: v-bind(backgroundColor);
    border: 1px solid v-bind(backgroundColor);
  }
}
</style>
